import { render } from "./rep030.vue?vue&type=template&id=68d0ab0b"
import script from "./rep030.vue?vue&type=script&lang=js"
export * from "./rep030.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__